import { render, staticRenderFns } from "./UserAwareOfInformationTable.vue?vue&type=template&id=816bba0a&scoped=true&"
import script from "./UserAwareOfInformationTable.vue?vue&type=script&lang=js&"
export * from "./UserAwareOfInformationTable.vue?vue&type=script&lang=js&"
import style0 from "./UserAwareOfInformationTable.vue?vue&type=style&index=0&id=816bba0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816bba0a",
  null
  
)

export default component.exports